import { LAYOUT } from '@admin/router/constant'

// tms
const TmsRouter = {
  path: '/tms',
  name: '',
  component: LAYOUT,
  children: [
    // 自营包裹
    {
      path: '/tms/package/list',
      name: 'TMSPackageList',
      component: () => import('@admin/views/tms/package/list/index.vue'),
      meta: {
        title: '自营包裹',
      },
    },
    {
      path: '/tms/package/box',
      name: 'TMSPackageBox',
      component: () => import('@admin/views/tms/package/box/index.vue'),
      meta: {
        title: '集箱管理',
      },
    },
    {
      path: '/tms/package/flight',
      name: 'TMSPackageFlight',
      component: () => import('@admin/views/tms/package/flight/index.vue'),
      meta: {
        title: '提单管理',
      },
    },
    // 渠道管理
    {
      path: '/tms/channel/logistics-list',
      name: 'TMSChannelLogisticsList',
      component: () => import('@admin/views/tms/channel/logistics/index.vue'),
      meta: {
        title: '物流渠道列表',
      },
    },
    {
      path: '/tms/channel/freight-list',
      name: 'TMSChannelFreightList',
      component: () => import('@admin/views/tms/channel/freight/index.vue'),
      meta: {
        title: '运费版本管理',
      },
    },
    {
      path: '/tms/channel/distribute-rule-engine',
      name: 'TMSChannelDistributeRuleEngine',
      component: () => import('@admin/views/tms/channel/ruleEngine/index.vue'),
      meta: {
        title: '渠道分配规则引擎',
      },
    },
    {
      path: '/tms/trajectory/matching',
      name: 'TMSChannelTrajectoryMatching',
      component: () => import('@admin/views/tms/trajectory/matching/index.vue'),
      meta: {
        title: '轨迹分配规则引擎',
      },
    },
    {
      path: '/tms/channel/delivery-info-config',
      name: 'TMSChannelDeliveryInfoConfig',
      component: () => import('@admin/views/tms/channel/deliveryConfig/index.vue'),
      meta: {
        title: '交运信息配置',
      },
    },
    {
      path: '/tms/package-sorting/record',
      name: 'TMSPackageSortingRecord',
      component: () => import('@admin/views/tms/packageSorting/record/index.vue'),
      meta: {
        title: '包裹分拣记录',
      },
    },
    {
      path: '/tms/channel/logistics-time/list',
      name: 'TMSChannelLogisticsTimeList',
      component: () => import('@admin/views/tms/channel/logisticsTime/index.vue'),
      meta: {
        title: '物流时长',
      },
    },
    {
      path: '/tms/channel/logistics-time/detail',
      name: 'TMSChannelLogisticsTimeDetail',
      component: () => import('@admin/views/tms/channel/logisticsTime/detail.vue'),
      meta: {
        title: '物流时长详情',
      },
    },
    {
      path: '/tms/waybill/replace',
      name: 'TMSWaybillReplace',
      component: () => import('@admin/views/tms/waybill/index.vue'),
      meta: {
        title: '面单替换',
      },
    },
    {
      path: '/tms/productManagement',
      name: 'TMSProductManageList',
      component: () => import('@admin/views/tms/productManage/list/index.vue'),
      meta: {
        title: '商品管理',
      },
    },
    {
      path: '/tms/customs-declaration/category-hs-config',
      name: 'TMSCustomsDeclarationCategoryHsCode',
      component: () => import('@admin/views/tms/customsDeclaration/categoryHsConfig/index.vue'),
      meta: {
        title: '品类海关编码配置',
      },
    },
    {
      path: '/tms/customs-declaration/hs-code',
      name: 'TMSCustomsDeclarationHsCode',
      component: () => import('@admin/views/tms/customsDeclaration/hsCode/index.vue'),
      meta: {
        title: '海关编码管理',
      },
    },
    {
      path: '/tms/waybillManagement/list',
      name: 'TMSWaybillManagementList',
      component: () => import('@admin/views/tms/waybillManagement/list/index.vue'),
      meta: {
        title: '运单管理',
      },
    },
  ],
}

export default TmsRouter
